import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { alignClass } from "../lib/align";
import { Button } from "../components/ui";
import SEO from "../components/SEO";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    setPost(null);
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost(false));
    window.scrollTo(0, 0);
  }, [slug]);

  if (post === false) return <div className="pt-40 pb-24 text-center container-x"><h1 className="text-2xl font-bold">Post not found</h1><Button to="/blog" className="mt-6">Back to Blog</Button></div>;
  if (!post) return <div className="pt-40 pb-24 text-center text-muted">Loading...</div>;

  return (
    <>
      <SEO title={post.seo_title || post.title} description={post.seo_description || post.excerpt} image={post.featured_image} type="article"
        jsonLd={{ "@context": "https://schema.org", "@type": "Article", headline: post.title, image: post.featured_image, author: post.author }} />
      <article className="pt-28 md:pt-36 pb-20 bg-white">
        <div className="container-x max-w-3xl">
          <Link to="/blog" className="text-sm text-gold font-semibold">← Back to Blog</Link>
          <span className="block mt-6 text-[11px] font-bold uppercase tracking-wide text-gold">{post.category}</span>
          <h1 className="mt-2 text-3xl md:text-5xl font-extrabold text-ink leading-tight">{post.title}</h1>
          <p className="mt-3 text-sm text-muted">By {post.author}</p>
          <div className="relative mt-8 rounded-xl2 overflow-hidden aspect-[16/9] border border-line"><img src={post.featured_image} alt={post.title} className="img-cover" /></div>
          <div className={`mt-8 prose text-muted leading-relaxed whitespace-pre-line text-[17px] ${alignClass(post.content_align)}`}>{post.content}</div>
        </div>
      </article>
      {post.recent?.length > 0 && (
        <section className="py-16 bg-sand">
          <div className="container-x max-w-4xl">
            <h2 className="text-2xl font-bold text-ink mb-8">More Articles</h2>
            <div className="grid sm:grid-cols-3 gap-5">
              {post.recent.map((r) => (
                <Link key={r.id} to={`/blog/${r.slug}`} className="group block rounded-xl2 border border-line overflow-hidden hover:shadow-soft">
                  <div className="relative aspect-[16/10] overflow-hidden"><img src={r.featured_image} alt={r.title} className="img-cover group-hover:scale-105 transition-transform duration-700" /></div>
                  <div className="p-4"><h3 className="font-semibold text-ink text-sm leading-snug">{r.title}</h3></div>
                </Link>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
